export enum BlogCategory {
  Company = 'company',
  Engineering = 'engineering',
  Mysql = 'mysql',
  Neki = 'neki',
  Postgres = 'postgres',
  Product = 'product',
  Tutorials = 'tutorials',
  Vitess = 'vitess'
}

export type ClusterArchitecture = 'aarch64' | 'x86_64'
export type ClusterEngine = 'postgresql' | 'mysql'

export type ClusterSku = {
  architecture: ClusterArchitecture | null
  cpu: string
  display_name: string
  enabled: boolean
  metal: boolean
  name: string
  provider: RegionProvider | null
  ram: number
  rate: number | null
  replica_rate: number | null
  storage: number | null
  storage_display_name: string | null
  default_vtgate: string
  default_vtgate_rate: number | null
  default_neki_router?: string | null
  default_storage_sku?: StorageSku | null
}

export type ClusterStorageType = 'gp3' | 'hyperdisk_balanced' | 'pd_ssd' | 'premium_v2_lrs'

export type StorageSku = {
  name: string
  storage_type: ClusterStorageType
  minimum_storage_bytes: number
  max_minimum_storage_bytes: number
}

export enum ClusterType {
  Standard = 'standard',
  Metal = 'metal'
}

export type Engine = 'neki' | 'postgres' | 'vitess'

export enum CaseStudyType {
  Postgres = 'postgres',
  Vitess = 'vitess'
}

export enum EventCategory {
  Conference = 'conference',
  Meetup = 'meetup'
}

export type Page = {
  page: string | null
  root: string
  url: string
}

export type Pagination = {
  hasNext: boolean
  hasPrev: boolean
  page: number
  totalPages: number
  url: string
}

export type Region = {
  current_default: boolean
  display_name: string
  location: string
  provider: RegionProvider
  slug: string
}

export enum RegionProvider {
  AWS = 'AWS',
  AZURE = 'AZURE',
  GCP = 'GCP'
}

export type Theme = 'ascii' | 'legacy'

export type VtgateSku = {
  autoscalable: boolean
  configurable: boolean
  cpu: string
  display_name: string
  name: string
  provider: RegionProvider | null
  ram: number
  rate: number | null
}

export type InstanceSizeSku = {
  name: string
  display_name: string
  cpu: string
  ram: number
  rate: number | null
}

export type BouncerSku = InstanceSizeSku
export type RouterSku = InstanceSizeSku
